export enum SheetAction {
  Save   = <any>'Save',
  Cancel = <any>'Cancel',
  Add    = <any>'Add',
  Custom = <any>'Custom'
}
